import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { setLanguage } from "@/store/preferences";
import i18n from "@/i18n/config";
import type { LanguageCode } from "@/types/i18n/types";

// TODO: Réactiver l'anglais en ajoutant "en-EN" à ce tableau
const AVAILABLE_LANGUAGES: LanguageCode[] = ["fr-FR"];
const DEFAULT_LANGUAGE: LanguageCode = "fr-FR";

export const I18nSync = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useAppDispatch();
  const language = useAppSelector((state) => state.preferences.language);

  useEffect(() => {
    // Si la langue stockée n'est plus disponible, revenir au français
    if (!AVAILABLE_LANGUAGES.includes(language)) {
      dispatch(setLanguage(DEFAULT_LANGUAGE));
      i18n.changeLanguage(DEFAULT_LANGUAGE);
      return;
    }

    if (i18n.language !== language) {
      i18n.changeLanguage(language);
    }
  }, [language, dispatch]);

  return <>{children}</>;
};
